import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { DutyTimeAllowanceAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-duty-time-allowance-audit-list',
  templateUrl: './duty-time-allowance-audit-list.component.html',
  styleUrls: ['./duty-time-allowance-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DutyTimeAllowanceAuditListComponent implements OnInit {
  @Input() dutyTimeAllowanceId: number;
  @Input() loading: boolean;
  @Input() dutyTimeAllowanceAudits: DutyTimeAllowanceAudit[];

  @Output() loadDutyTimeAllowance = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadDutyTimeAllowance.emit(this.dutyTimeAllowanceId);
  }

  onNextPage() {
    this.nextPage.emit(this.dutyTimeAllowanceId);
  }
}
